import { createSelector } from 'reselect';
import { values, get, compact, uniq } from 'lodash';

import { getCurrentAppointment } from 'modules/appointmentInfo/selectors/currentAppointment';
import { getAppointmentsByQueueType } from './appointmentsByQueueType';

export const getUsersIds = createSelector(
  getAppointmentsByQueueType,
  getCurrentAppointment,
  ({ entities }, currentAppointment) => {
    const currentAppointmentParticipants = get(currentAppointment, 'participants', []).map(({ user }) => user.userId);

    const userIds = values(entities).reduce((acc, { participants, subjects }) => {
      const participantsIds = participants.map(({ user }) => user.userId);
      const subjectsIds = subjects.map(({ user }) => user.userId);
      return [...acc, ...participantsIds, ...subjectsIds];
    }, currentAppointmentParticipants);

    return uniq(compact(userIds));
  },
);
